import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://pioneer-service.dev.onyxcentersource.com',
  hostname: 'pioneer.dev.onyxcentersource.com',
  portalUrl: 'https://portal.dev.onyxcentersource.com',
  allowApiDocs: true
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/environments/environment.dev.ts